module.exports = __webpack_public_path__ + "static/media/ic_mail_menu.e1d11292.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_mail_menu.svg
// module id = 287
// module chunks = 0